// Compact emoji picker — no external dependency.
// Small curated set organized by category.

export const EMOJI_CATEGORIES = [
  {
    id: "smileys",
    label: "😀",
    emojis: [
      "😀","😃","😄","😁","😆","😅","🤣","😂","🙂","🙃",
      "😉","😊","😍","😘","😗","😙","😚","😋","😜","🤪",
      "😎","🤩","🥳","😏","🤔","🤨","😐","😑","😶","🙄",
      "😴","🤤","🥱","🤗","😳","😱","😨","😰","😥","😢",
      "😭","😤","😡","🤬","🥺","🤯","🥲","😇","🤠","🤓",
    ],
  },
  {
    id: "people",
    label: "👋",
    emojis: [
      "👋","🤚","✋","🖖","👌","🤏","✌️","🤞","🤟","🤘",
      "👍","👎","👊","✊","🤛","🤜","👏","🙌","👐","🤝",
      "🙏","💪","🧠","👀","👣","🦶","🦾","🦿","🕺","💃",
    ],
  },
  {
    id: "nature",
    label: "🌿",
    emojis: [
      "🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🐯",
      "🦁","🐮","🐷","🐸","🐵","🌵","🎄","🌲","🌳","🌴",
      "🌱","🌿","☘️","🍀","🎋","🍃","🍂","🍁","🌸","🌻",
    ],
  },
  {
    id: "food",
    label: "🌮",
    emojis: [
      "🌮","🌯","🥑","🍕","🍔","🌭","🥪","🥗","🌶️","🫐",
      "🍎","🍏","🍊","🍋","🍌","🍉","🍇","🍓","🥝","🍒",
      "☕","🍵","🧉","🍺","🍻","🥂","🍷","🥃","🍹","🧋",
    ],
  },
  {
    id: "activity",
    label: "⚽",
    emojis: [
      "⚽","🏀","🏈","⚾","🎾","🏐","🏓","🥊","🎯","🎮",
      "🎧","🎼","🎹","🎸","🥁","🎤","🎬","📷","🎨","🕹️",
    ],
  },
  {
    id: "objects",
    label: "💻",
    emojis: [
      "💻","🖥️","⌨️","🖱️","💾","📱","🔋","🔌","💡","🔦",
      "📚","📖","📝","✏️","🖊️","📌","📎","🗂️","📁","📅",
    ],
  },
  {
    id: "symbols",
    label: "💫",
    emojis: [
      "❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔",
      "💯","💥","💫","⭐","🌟","✨","⚡","🔥","🎉","🎊",
      "🚀","🛸","🌈","🌙","☀️","☁️","❄️","🎁","🔔","✅",
    ],
  },
];

export const ALL_EMOJIS = EMOJI_CATEGORIES.flatMap((c) => c.emojis);
